import React from "react";
import "../scss/whyMotoDoctor.css";
import ico1 from "../Wesite Icons/Fast Response.png";
import ico2 from "../Wesite Icons/Verified Mechanics.png";
import ico4 from "../Wesite Icons/Easy Booking.png";
import ico5 from "../Wesite Icons/Transparent Pricing.png";
import ico6 from "../Wesite Icons/Citywide Coverage.png";
import ico7 from "../Wesite Icons/Peace of Mind.png";





const features = [
  {
    title: "Fast Response",
    description: "We reach you within 30–45 minutes",
    icon: ico1,
    isImage: true,
  },
  {
    title: "Verified Mechanics",
    description: "Skilled, background-checked professionals",
    icon: ico2,
    isImage: true,
  },
  {
    title: "Easy Booking",
    description: "Simple MotoDoctor app interface",
    icon: ico4,
    isImage: true,
  },
  {
    title: "Transparent Pricing",
    description: "No surprises",
    icon: ico5,
    isImage: true,
  },
  {
    title: "Citywide Coverage",
    description: "Across all zones of Chennai",
    icon: ico6,
    isImage: true,
  },
  {
    title: "Peace of Mind",
    description: "Help is always a tap away",
    icon: ico7,
    isImage: true,
  },
];

const WhyChooseUs = () => {
  return (
    <section className="why-choose-section">
      <div className="why-choose-title">Why Chennai Riders Choose MotoDoctor</div>

      <div className="why-choose-grid">
        {features.map((feature, index) => (
          <div className="why-choose-card" key={index}>
            <div className="why-icon">
              {feature.isImage ? (
                <img
                  src={feature.icon}
                  alt={feature.title}
                  style={{
                    width: "40px",
                    height: "40px",
                    objectFit: "contain",
                    display: "block",
                  }}
                />
              ) : (
                <span
                  style={{
                    fontSize: "32px",
                    lineHeight: "1",
                    display: "block",
                  }}
                >
                  {feature.icon}
                </span>
              )}
            </div>

            <div>
              <h3 className="why-title">{feature.title}</h3>
              <p className="why-description">{feature.description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default WhyChooseUs;
